import React from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom';

// Js
import { GlobalContext } from '../../Global/GlobalContext';

// Components
import List from './List';
import Remove from './Remove';
import Update from './Update';
import Add from './Add';

const Partners = () => {
    const {setHeaderData} = React.useContext(GlobalContext);

    React.useState(() => {
        setHeaderData("Parceiros", "Adicione, edite e remova seus parceiros");
    })

    return (
        <Routes>
            <Route path="/" exact element={<List />} />
            <Route path="/adicionar" element={<Add />} />
            <Route path="/atualizar/:id" element={<Update />} />
            <Route path="/remover/:id" element={<Remove />} />
        </Routes>
    )    
}

export default Partners
